import { render, staticRenderFns } from "./PlansView.vue?vue&type=template&id=136853e6&scoped=true&"
import script from "./PlansView.vue?vue&type=script&lang=js&"
export * from "./PlansView.vue?vue&type=script&lang=js&"
import style0 from "./PlansView.vue?vue&type=style&index=0&id=136853e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136853e6",
  null
  
)

export default component.exports